<div class="text-center bg_image">
    <div class="row">
        <div class="col-md-6 mt-5">
            <img src="assets\img\background\NBR_logo.jpg" class="nbr_logo">
        </div>
        <!-- <div class="col-md-6 mt-4">
            <img src="assets\img\logo\mujib_borsho.svg" class="mujib100_logo">
        </div> -->
    </div>
    <div class="main_section container">
        <div class="col-12 text-center text-style">
            <!-- <marquee direction="right" behavior="alternate">
                <label>This module is under development.</label>
            </marquee> -->
            <label>This module is under development.</label>
        </div>
    </div>
    <div class="row mt-3 footer">
        <div class="col-12">
            <button type="button" class="btn btn-sm backBtn mb-3" (click)="onBacktoMainPage()">
                <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left"
                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                </svg>&nbsp;
                Back to main</button>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>